<template lang="pug">
    .settings-page.settings-bookings
        settings-page-head
        .settings-page__body
            .text-right.mb-4.settings-bookings-menu(v-if="authUser.game_master")
                .btn(@click="page = 1, showReservations = true" :class="{ 'btn-primary': showReservations }") Reservations
                .btn(@click="page = 1, showReservations = false" :class="{ 'btn-primary': !showReservations }") My Bookings

            .scrollable-table
                table.table.table-borderless.table-striped.settings-table.settings-table
                    thead
                        template(v-if="showReservations")
                            th Player
                            th Location
                        template(v-else)
                            th Game Master
                        th Date And Time
                        th Number Of Hours
                        th Reserved Games
                        th Add-Ons
                        th Comments
                        th Price
                        th Status
                        th
                    tbody
                        tr(v-for="reservation in tableData")
                            template(v-if="showReservations")
                                td {{ reservation.user.data.name }}
                                td {{ reservation.location && reservation.location.address }}
                            template(v-else)
                                td {{ reservation.product.data.user.data.name }}
                            td
                                time(:datetime="reservation.start_at") {{ reservationTime(reservation) }}
                                div(v-if="reservation.location.timezone_name") {{ reservation.location.timezone_name }}
                            td {{ reservation.slots }}
                            td {{ reservation.game_title || reservation.game }}
                            td {{ addons(reservation) || 'No' }}
                            td
                                template(v-if="reservation.notes")
                                    a.bnt-see-details(@click="reservationWithNote = reservation") See Details
                            td {{ reservation.order_item.data.total | currency }}
                            td
                                .settings-table__status(:class="reservation.state") {{ reservation.state }}
                            td.bookings-table-actions
                                template(v-if="showReservations")
                                    template(v-if="reservation.state == 'pending'")
                                        re-button.btn-primary.btn-lg(@click="accept(reservation)" :loading="accepting[reservation.id]" :disabled="declining[reservation.id]") Accept
                                        re-button.btn-outline-primary.btn-lg(@click="decline(reservation)" :loading="declining[reservation.id]" :disabled="accepting[reservation.id]") Decline
                                    template(v-if="reservation.state == 'confirmed'")
                                        re-button.btn-outline-primary.btn-lg(@click="cancelByGameMaster(reservation)" :loading="cancelingByGameMaster[reservation.id]" :disabled="cancelingByGameMaster[reservation.id]") Cancel
                                template(v-else)
                                    template(v-if="reservation.state == 'pending' || reservation.state == 'confirmed'")
                                        re-button.btn-outline-primary.btn-lg(@click="cancelByPlayer(reservation)" :loading="cancelingByPlayer[reservation.id]" :disabled="cancelingByPlayer[reservation.id]") Cancel

            settings-table-paging(v-if="pages > 1" :page="page" :pages="pages" @click="page = $event.page")

        re-modal(v-if="reservationWithNote" container-class="re-modal-sm" @close="reservationWithNote = null")
            .re-modal-title Additional Comments
            .re-modal-content
                p {{ reservationWithNote.notes }}

</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

const PAGE_SIZE = 7

export default {
    name: 'settings-bookings',

    data() { return {
        showReservations: false,
        reservations: [],
        bookings: [],
        accepting: {},
        declining: {},
        cancelingByGameMaster: {},
        cancelingByPlayer: {},
        page: 1,
        reservationWithNote: null,
    }},

    computed: {
        ...mapGetters(['authUser']),

        pages() {
            const items = this.showReservations ? this.reservations.length : this.bookings.length
            return Math.floor((items - 1) / PAGE_SIZE + 1)
        },

        tableData() {
            const items = this.showReservations ? this.reservations : this.bookings
            return items.slice(PAGE_SIZE * (this.page - 1), PAGE_SIZE * this.page)
        },
    },

    async created() {
        if (this.authUser.game_master) {
            this.showReservations = true
            const { data: { data: reservations } } = await axios.get('/api/customer/game-master/reservation?include=user,product,order_item&order=id:desc')
            this.reservations = reservations
        }

        const { data: { data: bookings } } = await axios.get('/api/customer/reservation?include=product.user,order_item&order=id:desc')
        this.bookings = bookings
    },

    methods: {
        reservationTime(reservation) {
            return moment.parseZone(reservation.start_at).add(reservation.location.timezone_offset, 's').format('MMM D, h:mm A')
        },

        async accept(reservation) {
            await this.action(reservation, `/api/customer/game-master/reservation/${reservation.id}/accept`, this.accepting)
        },

        async decline(reservation) {
            await this.action(reservation, `/api/customer/game-master/reservation/${reservation.id}/decline`, this.declining)
        },

        async cancelByGameMaster(reservation) {
            await this.action(reservation, `/api/customer/game-master/reservation/${reservation.id}/cancel`, this.cancelingByGameMaster)
        },

        async cancelByPlayer(reservation) {
            await this.action(reservation, `/api/customer/game-master/reservation/${reservation.id}/cancel-by-player`, this.cancelingByPlayer)
        },

        async action(reservation, endpoint, loading) {
            try {
                this.$set(loading, reservation.id, true)
                const { data: { data } } = await axios.post(endpoint)
                Object.assign(reservation, data)
            } finally {
                this.$set(loading, reservation.id, false)
            }
        },

        addons(reservation) {
            if (reservation.addon_titles) {
                return Object.values(reservation.addon_titles).join(', ')
            }

            return Object.entries(reservation.upgrades || {}).map(a => {
                const upgrade = reservation.product.data.upgrades.find(u => u.name == a[0])
                if (upgrade) {
                    return upgrade.title
                }
            }).join(', ')
        },
    }
}
</script>
